import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { AccordionBody } from './AccordionBody';
import { AccordionItem } from './AccordionItem';
import { AccordionPanel } from './AccordionPanel';
import styles from '@dtsl/css-accordion/dist/index.module.css';
export const AccordionContext = /*#__PURE__*/React.createContext();

// uses compound pattern
export const ACCORDION_TYPE = {
  SINGLE_OPENABLE: 'singleOpenable',
  MULTI_OPENABLE: 'multiOpenable'
};
function Accordion(props) {
  const {
    children,
    className = '',
    accordionType = ACCORDION_TYPE.SINGLE_OPENABLE
  } = props;
  const [visibleAccordionItems, setVisibleAccordionItems] = useState(Array(children.length).fill(false));
  const accordionWrapperClasses = classNames({
    [styles['sib-accordion']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      accordionType,
      visibleAccordionItems,
      setVisibleAccordionItems
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: accordionWrapperClasses
  }, React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      key: index,
      index
    });
  })));
}
Accordion.propTypes = {
  accordionType: PropTypes.oneOf(Object.values(ACCORDION_TYPE)),
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
Accordion.Item = AccordionItem;
Accordion.Panel = AccordionPanel;
Accordion.Body = AccordionBody;
export default Accordion;